import { Preferences } from "@capacitor/preferences";
import { getShopCatalog } from "@phaser/core/shop/shopCatalog";

const OWNED_ITEMS_KEY = "monspot_shop_owned_items";

class ShopInventoryManager {
  private ownedItemIds = new Set<string>();
  private initialized = false;

  async init() {
    if (this.initialized) return;

    const { value } = await Preferences.get({ key: OWNED_ITEMS_KEY });

    if (value) {
      try {
        const parsed: string[] = JSON.parse(value);
        this.ownedItemIds = new Set(parsed);
      } catch {
        this.ownedItemIds = new Set();
      }
    } else {
      // 첫 실행 시 기본 소유 아이템 세팅
      getShopCatalog().forEach((item) => {
        if (item.defaultOwned || item.defaultEquipped) {
          this.ownedItemIds.add(item.id);
        }
      });

      await this.save();
    }

    this.initialized = true;
  }

  isOwned(itemId: string) {
    return this.ownedItemIds.has(itemId);
  }

  async addOwnedItem(itemId: string) {
    this.ownedItemIds.add(itemId);
    await this.save();
  }

  private async save() {
    await Preferences.set({
      key: OWNED_ITEMS_KEY,
      value: JSON.stringify([...this.ownedItemIds]),
    });
  }
}

export const shopInventoryManager = new ShopInventoryManager();
